import React, { ReactNode, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

interface LayoutProps {
  children: ReactNode;
  username?: string;
  isSuperuser?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, username, isSuperuser }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen">
      <Sidebar isSuperuser={isSuperuser} collapsed={collapsed} onCollapsedChange={setCollapsed} />
      <div
        className="flex-1 flex flex-col"
        onClick={() => { if (!collapsed) setCollapsed(true); }}
      >
        <Header username={username} />
        <main className="flex-1 p-8 bg-gray-50">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
